import axios from 'axios';
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=utf-8';
// axios.defaults.baseURL = process.env.BASE_API;
axios.defaults.processData = false;
axios.defaults.contentType = false;
export function post(url, params, config) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, config)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/service/uploadfetch.js